import { Component, EventEmitter, OnInit, Output, SecurityContext, ViewEncapsulation, ɵɵtrustConstantResourceUrl } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Editor, Toolbar } from 'ngx-editor';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DialogService } from 'src/app/services/dialog.service';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';


@Component({
    selector: 'app-form-view-rich-text',
    templateUrl: './form-view-rich-text.component.html',
    styleUrls: ['./form-view-rich-text.component.scss'],
    standalone: false
})
export class FormViewRichTextComponent implements OnInit {

  canConfig:boolean = false;
  config:columnsDef;
  group: UntypedFormGroup;
  entityName:string;
  entityDesc:string;
  row:Object;
  pk:Object;
  toolTipText = null;
  showBuscaDados:boolean = true;
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();
  
  tabindex:string;
  editor: Editor;
  html: '';
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ]
  
  constructor(private sanitizer: DomSanitizer,public dynaServices:DynamicFormsService, private dialog:DialogService, private http:HTTPService, private snackServices:SnackbarService) {  }

  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  bluring(event){
      this.blurEvent.next(event)
  }
  
  ngOnInit() {
    this.editor = new Editor({
      keyboardShortcuts: true,
      
    });

    this.html = this.group.get(this.config.COLUMNNAME).value;
    this.group.get(this.config.COLUMNNAME).valueChanges.subscribe(data=>{
      this.editing();
    });
  }

  get doc(): AbstractControl {
    return this.group.get(this.config.COLUMNNAME);
  }


  public sanitizeHtmlContent(htmlstring): SafeHtml {
    return this.sanitizer.sanitize(SecurityContext.HTML, htmlstring);
  }

  ngOnDestroy(){
    this.editor.destroy();
  }

  ngAfterViewInit(){
  }

  editing(){
    this.editEvent.next(true)
  }
}

